// extracted by mini-css-extract-plugin
module.exports =  {"hedy":"Hedy-_Ws6__hedy"};